import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import cn from 'classnames';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { Button } from '@bibliocommons/base-buttons';
import { Cross } from '@bibliocommons/base-icons';
import './ActiveFilterToken.scss';

export default class ActiveFilterToken extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleToggleFilter');
  }

  handleToggleFilter() {
    this.props.handleToggleFilter(this.props.fieldId, this.props.filter);
  }

  render() {
    const btnClass = cn('cp-filter-token', this.props.className);
    return (
      <Button
        handleClick={this.handleToggleFilter}
        data-test-id={`${this.props.fieldId}-${this.props.filter.get('value')}-active-filter`}
        className={btnClass}>
        {this.props.filterLabel}
        <Cross className="extra-small" />
      </Button>
    );
  }
}

ActiveFilterToken.propTypes = {
  className: PropTypes.string,
  fieldId: PropTypes.string.isRequired,
  filter: ImmutablePropTypes.map,
  filterLabel: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/components/shared/Facets/ActiveFilterToken/ActiveFilterToken.jsx